<div class="network-projects">
  <div class="network-projects__container" *ngIf="posts$ | async as posts">
    <h1 class="network-projects__title text-base-font-primary">{{ 'global.network-projects' | translate }}</h1>
    <div class="network-projects__card">
      <ng-container *ngIf="isShowNormalPosts$ | async; else carouselTemplate">
        <app-post-network-projects [data]="posts"></app-post-network-projects>
      </ng-container>
      <ng-template #carouselTemplate>
        <app-carousel-network-projects [data]="posts"></app-carousel-network-projects>
      </ng-template>
    </div>
  </div>
</div>
